// extracted by mini-css-extract-plugin
export default {"container":"VA-z","dimension":"WA-z","dimensionLabels":"XA-z"};